// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#5b61ff","seconderyWhite":"#fafafa","primaryWhite":"#fff","testimonialItem":"testimonialItem_testimonialItem__cxwWJ","meta":"testimonialItem_meta__1U3-H"};